import { getBaseUrl } from "./base_url"
import { type ExactagData } from "@otto-ec/online-marketing/exactag"

enum RequestMethod {
    get = "GET",
}

async function fetchJSON(url: string, method: RequestMethod): Promise<ExactagData> {
    const response = await fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json",
        },
    })

    if (!response.ok) {
        return {}
    }
    return (await response.json()) as ExactagData
}

export async function fetchExactagCustomerData(): Promise<ExactagData> {
    const baseUrl = getBaseUrl(document)
    return await fetchJSON(`${baseUrl}/tags`, RequestMethod.get)
}
